import { LoaderActionTypes } from './loader.action';

/**
 * global             - global loader for blocking complete page, controlling <app-loader>
 * active             - count of all non-global loaders
 * actionsInProgress  - list of all active loader
 */
export interface LoaderState {
  global: boolean;
  active: number;
  actionsInProgress: any[];
}

const initialState = {
  global: false,
  active: 0,
  actionsInProgress: [],
};

export function reducer(state = initialState, action: any): LoaderState {
  switch (action.type) {
    case LoaderActionTypes.GLOBAL_SHOW: {
      return {
        ...state,
        global: true,
      };
    }
    case LoaderActionTypes.GLOBAL_HIDE: {
      return {
        ...state,
        global: false,
      };
    }
    case LoaderActionTypes.SHOW: {
      const isActionAlreadyInProgress = state.actionsInProgress.filter(
        (currentAction: any) => currentAction === action.payload.type,
      ).length;

      if (isActionAlreadyInProgress) {
        return state;
      }

      const newActionsInProgress = [
        ...state.actionsInProgress,
        action.payload.type,
      ];

      return {
        ...state,
        active: newActionsInProgress.length,
        actionsInProgress: newActionsInProgress,
      };
    }
    case LoaderActionTypes.HIDE: {
      const newActionsInProgress = action.payload.triggerAction
        ? state.actionsInProgress.filter(
            (currentAction: any) =>
              currentAction !== action.payload.triggerAction,
          )
        : state.actionsInProgress;

      return {
        ...state,
        actionsInProgress: newActionsInProgress,
        active: state.active > 0 ? newActionsInProgress.length : 0,
      };
    }
    case LoaderActionTypes.HIDE_ALL: {
      return initialState;
    }
    default:
      return state;
  }
}
